import { useEffect, useState } from 'react';
import type { ReactNode } from 'react';

import { useAppDispatch } from '../../../hooks';
import { refreshToken } from './authSlice';

const AuthPersist = ({ children }: { children: ReactNode }) => {
  const [ready, setReady] = useState(false);
  const dispatch = useAppDispatch();

  useEffect(() => {
    const getPersistedState = async () => {
      await dispatch(refreshToken());
      setReady(true);
    };

    getPersistedState();
  }, [dispatch]);

  if (!ready) {
    return null;
  }

  return <>{children}</>;
};

export default AuthPersist;
